import React, { useEffect, useState } from 'react';
import type { SystemSettings as SystemSettingsType } from '../../types';
import { GeneralSettings } from './GeneralSettings';
import { SecuritySettings } from './SecuritySettings';
import { EmailSettings } from './EmailSettings';
import { BackupSettings } from './BackupSettings';

const defaultSettings: SystemSettingsType = {
  general: {
    companyName: '',
    timeZone: 'utc',
    unit: 'Inches'
  },
  security: {
    twoFactorAuth: false,
    passwordStrength: 'strong'
  },
  email: {
    smtpServer: '',
    smtpPort: 587,
    fromAddress: '',
    fromName: ''
  },
  backup: {
    autoBackup: false,
    backupFrequency: 'daily',
    retentionDays: 30
  }
};

export const SystemSettings: React.FC = () => {
  const [settings, setSettings] = useState<SystemSettingsType>(defaultSettings);
  
  // Load settings from localStorage on component mount
  useEffect(() => {
    const loadSettings = () => {
      try {
        const savedSettings = localStorage.getItem('settings');
        if (savedSettings) {
          const parsedSettings = JSON.parse(savedSettings);
          setSettings(parsedSettings);
        }
      } catch (error) {
      }
    };
    loadSettings();
  }, []);

  // Save settings to localStorage whenever settings change
  useEffect(() => {
    try {
      localStorage.setItem('settings', JSON.stringify(settings));
    } catch (error) {
    }
  }, [settings]);

  const handleGeneralSettingChange = (field: keyof SystemSettingsType['general'], value: string) => {
    setSettings(prev => ({
      ...prev,
      general: {
        ...prev.general,
        [field]: value
      }
    }));
  };

  const handleSecuritySettingChange = (field: keyof SystemSettingsType['security'], value: boolean | SystemSettingsType['security']['passwordStrength']) => {
    setSettings(prev => ({
      ...prev,
      security: {
        ...prev.security,
        [field]: value
      }
    }));
  };

  const handleEmailSettingChange = (field: keyof SystemSettingsType['email'], value: string | number) => {
    setSettings(prev => ({
      ...prev,
      email: {
        ...prev.email,
        [field]: value
      }
    }));
  };

  const handleBackupSettingChange = (field: keyof SystemSettingsType['backup'], value: boolean | string | number) => {
    setSettings(prev => ({
      ...prev,
      backup: {
        ...prev.backup,
        [field]: value
      }
    }));
  };

  const handleBackupNow = () => {
    // TODO: Implement backup functionality
  };

  return (
    <div className="space-y-8">
      <GeneralSettings
        timeZone={settings.general.timeZone}
        unit={settings.general.unit}
        onTimeZoneChange={(value) => handleGeneralSettingChange('timeZone', value)}
        onUnitChange={(value) => handleGeneralSettingChange('unit', value)}
      />

      <SecuritySettings
        twoFactorAuth={settings.security.twoFactorAuth}
        passwordStrength={settings.security.passwordStrength}
        onTwoFactorAuthChange={(value) => handleSecuritySettingChange('twoFactorAuth', value)}
        onPasswordStrengthChange={(value) => handleSecuritySettingChange('passwordStrength', value)}
      />

      {/* <EmailSettings
        settings={settings.email}
        onSettingChange={handleEmailSettingChange}
      />

      <BackupSettings
        settings={settings.backup}
        onSettingChange={handleBackupSettingChange}
        onBackupNow={handleBackupNow}
      /> */}
    </div>
  );
}; 